let RMCalc = function (app, mid, id = null, template = null) {
    this.app = app;
    this.container = null;
    this.mid = mid;
    this.id = id;
    this.fabrics = app.params.init_data.fabrics;

    this.openFabricsBlock_button = null;
    this.data = null;
    this.template = template;
    this.prices = null;
    this.crutch = null;
    this.options = null;
    this.params = null;
    this.header = '';
    this.materials = {};
    this.contentBlock = null;
    this.calcItemsWrapper = null;
    this.calcItemsAddButton = null;

    this.calcItemsBlock = null;
    this.calcItemsHeader = null;

    this.matAmounts = {};

    this.htmlTemplate = '';
    this.htmlParam = '';
    this.htmlParamOption = '';

    this.order = null;
    this.sizes = [];
    this.selectors = {};
    this.totalFields = {};
    if (this.app.contentBlock) this.contentBlock = this.app.contentBlock;

    this.items = [];
    this.itemsCornice = [];
    this.itemsCount = 0;

    this.discount = 0;

    this.fabricState = false;
    this.systemsState = false;

    this.cornice = false; // Карниз или система
    this.vformCornice = false;
    this.vformMaterial = false;
    this.kit = false;

    this.alert = false;

    this.corniceOpened = false;

    this.packingData = [];

    this.amountList = {
        6: '6',
        12: '12',
        18: '18',
        24: '24',
        30: '30',
        36: '36',
        42: '42',
        48: '48',
        54: '54',
        60: '60',
        66: '66',
        72: '72',
        78: '78',
        84: '84',
        90: '90',
        96: '96',
        102: '102',
        108: '108',
        114: '114',
        120: '120',
        126: '126',
        132: '132',
        138: '138',
        144: '144',
        150: '150',
        156: '156',
        162: '162',
        168: '168',
        174: '174',
        180: '180',
        186: '186',
        192: '192',
        198: '198',
        204: '204',
        210: '210',
        216: '216',
        222: '222',
        228: '228',
        234: '234',
        240: '240'
    }

    this.amountAssignment = {}

    this.prepareTemplate = function (html, model) {
        for (let key in model) {
            if (Object.prototype.hasOwnProperty.call(model, key)) {
                html = html.replace(new RegExp("{{" + key + "}}", 'g'), model[key]);
            }
        }
        return html;
    };

    this.init = function () {
        this.packingData = this.app.params.init_data.packSize;

        if (!this.id) this.id = Math.floor(Math.random() * (9999 - 1000)) + 1000;

        if (this.mid > 100 && this.mid < 110) {
            this.cornice = true;
            this.data = this.app.params.init_data.itemsCornice[this.mid];
            this.header = this.data.name;
        } else if (this.mid == 201) {
            this.vformCornice = true;
            this.data = this.app.params.init_data.itemsVForm[this.mid];
            this.header = this.data.name;
        } else if (this.mid == 202) {
            this.vformMaterial = true;
            this.data = this.app.params.init_data.itemsVForm[this.mid];
            this.header = this.data.name;
        } else if (this.mid == 301) {
            this.kit = true;
            this.data = this.app.params.init_data.itemsKits[this.mid];
            this.header = this.data.name;
        } else if (this.mid > 400) {
            this.data = this.app.params.init_data.itemsByMat[this.mid];
            this.header = this.data.nameRu + ' ' + this.data.name;
        } else {
            this.data = this.app.params.init_data.items[this.mid];
            this.header = this.data.nameRu + ' ' + this.data.name;
        }

        if (this.data.discount) {
            this.discount = this.data.discount;
        }

        let isNew = false;
        if (!this.template) {
            this.template = window.clone(this.data.template);
            isNew = true;
        }

        this.template.price = 0;
        this.template.sale = 0;
        this.template.salePrice = 0;
        this.crutch = this.data.crutch;
        this.params = this.data.params;

        if (mid > 400) {
            let refMid = mid - 400;
            this.params = this.app.params.init_data.items[refMid].params;
        }

        this.prices = this.data.multiple_prices;

        if (this.params) {
            this.calcMatAmounts();
        }

        let first = null;

        if (this.mid != 202) {
            for (let n in this.prices) {
                if (Object.prototype.hasOwnProperty.call(this.prices, n)) {
                    if (!this.materials[n]) {
                        if (!first) first = n;
                        if (this.mid > 400) {
                            this.materials[n] = this.app.params.init_data.materials_bymat[n];
                        } else {
                            this.materials[n] = this.app.params.init_data.materials[n];
                        }
                    }
                }
            }
        } else if (this.mid == 202) {
            this.materials = this.app.params.init_data.materials_vform
        }


        if ((!this.prices[this.template.material] || this.materials[this.template.material]) && !this.cornice && !this.vformCornice) {
            if (first) this.template.material = parseInt(first);
        } else {
            console.log('alarm!')
            this.template.material = 0;
        }

        if (isNew) {
            if (this.materials[this.template.material] && this.materials[this.template.material].available == "red") {
                for (let mat in this.materials) {
                    if (this.materials[mat].available == "green") {
                        this.template.material = this.materials[mat].id_good;
                        break;
                    }
                }
            }
        }

        if (Object.keys(this.materials).length <= 1 && this.openFabricsBlock_button)
            this.openFabricsBlock_button.style.display = 'none';
        this.template.mid = this.mid;
        this.chooseFabric(this.template.material);

        if (!this.cornice && !this.vformCornice && !this.vformMaterial && !this.kit) {
            this.template.amount = this.prices[this.template.material][this.template.gab_height][this.template.gab_width].amount;
        } else if (!this.vformCornice && !this.vformMaterial && !this.kit) {
            this.template.amount = 4;
        }
        this.reCalc();
    };

    this.heightChange = function (ev) {
        this.template.gab_height = parseInt(ev.value);
        this.inflateWidthSelector();
        this.reCalc();
    };
    this.widthChange = function (ev) {
        this.template.gab_width = parseInt(ev.value);
        this.inflateAmountSelector();
        this.reCalc();
    };
    this.amountChange = function (ev) {
        this.template.amount = parseInt(ev.value);
        this.reCalc();
    };
    this.inflateHeightSelector = function (first = null) {
        if (this.template.material > 0) {
            if (this.prices[this.template.material]) {
                this.selectors.height.innerHTML = '';
                if (first && !this.prices[this.template.material][first]) first = null;
                for (let n in this.prices[this.template.material]) {
                    let option = document.createElement('option');
                    option.value = n;
                    option.innerHTML = (n / 10).toString();
                    this.selectors.height.appendChild(option);
                    if (!first) {
                        first = n;
                    } else {
                        if (first === n) option.selected = true;
                    }
                }
                this.template.gab_height = first;
            }
        }
    };

    this.getMatAmount = function (template) {
        return this.app.basket.getMatAmount(template);
    };

    this.calcMatAmounts = function () {
        this.matAmounts = {};
        for (let key in this.app.basket.matAmounts) {
            if (Object.prototype.hasOwnProperty.call(this.app.basket.matAmounts, key) && this.app.basket.matAmounts[key]) {
                this.matAmounts[key] = this.app.basket.matAmounts[key];
            }
        }

        for (let key = this.items.length - 1; key >= 0; key--) {
            if (this.items[key]) {
                if (!this.items[key].matAmount) {
                    this.items[key].matAmount = this.getMatAmount(this.items[key]);
                } else {
                    this.items[key].matAmount = parseFloat(this.items[key].matAmount);
                    if (isNaN(this.items[key].matAmount)) this.items[key].matAmount = 0;
                }
                if (!this.matAmounts[this.items[key].material]) this.matAmounts[this.items[key].material] = 0;
                this.matAmounts[this.items[key].material] += this.items[key].matAmount;
            }
        }
    };

    this.store = function () {
        if (!this.cornice) {
            this.template.matAmount = this.getMatAmount(this.template);
            if (this.discount) this.template.discount = this.discount;

            if (this.template.material) {
                if (!this.matAmounts[this.template.material]) this.matAmounts[this.template.material] = 0;
                if ((this.materials[this.template.material] && this.materials[this.template.material].gdsInStock) || this.app.mode == 2) {
                    this.items[this.items.length] = window.clone(this.template);

                    this.itemsCount = this.items.length;

                    if (this.itemsCount > 1) {
                        this.remove(0);
                    }

                    this.id = Math.floor(Math.random() * (9999 - 1000)) + 1000;
                    this.proccess();
                } else if (this.template.mid != 301) {
                    if (!this.app.noAlerts) {
                        alert('Недостаточно материала! Выберите другой материал!');
                    }
                    this.template.amount = 0;
                }
            }
        } else {
            if (this.discount) this.template.discount = this.discount;
            this.itemsCornice[this.itemsCornice.length] = window.clone(this.template);
            this.itemsCount = this.itemsCornice.length;

            if (this.itemsCount > 1) {
                this.remove(0);
            }

            this.id = Math.floor(Math.random() * (9999 - 1000)) + 1000;
            this.proccess();
        }
    };

    this.remove = function (id) {
        this.items.splice(id, 1);
        this.itemsCount = this.items.length;
        this.proccess();
    };

    this.proccess = function () {
        if (this.itemsCount === 0) {
            if (this.calcItemsWrapper) this.calcItemsWrapper.style.display = 'none';
            if (this.calcItemsAddButton) this.calcItemsAddButton.style.display = 'none';
        } else {
            if (this.calcItemsWrapper) this.calcItemsWrapper.style.display = 'block';
            if (this.calcItemsAddButton) this.calcItemsAddButton.style.display = 'inline-block';
            if (this.calcItemsBlock) {
                this.calcItemsBlock.innerHTML = '';
                if (this.calcItemsHeader) this.calcItemsBlock.appendChild(this.calcItemsHeader);
            }
        }
        this.calcMatAmounts();
    };

    this.createProccessItemModel = function (num, key, item) {
        let name = '';
        let material = '';
        let img = '';
        let paramsHTML = '';
        let data = null;
        if (this.data) data = this.data;
        if (data && data.name) name = data.nameRu + ' ' + data.name;
        if (this.materials && this.materials[item.material]) {
            material = this.materials[item.material].name;
            img = this.materials[item.material].img;
        }
        if (data && data.params) {
            for (let key in data.params) {
                if (Object.prototype.hasOwnProperty.call(data.params, key)) {
                    if (item[key]) {
                        let param = data.params[key];
                        if (param.options && param.options[key + '_' + item[key]]) {
                            let option = param.options[key + '_' + item[key]];
                            paramsHTML += '<b>' + param.name + ': </b>' + option.name + '<br />';
                        }
                    }
                }
            }
        }
        return {
            module: 'basket',
            key: key,
            num: num,
            name: name,
            material: material,
            img: img,
            width: item.gab_width / 10,
            height: item.gab_height / 10,
            amount: item.amount,
            price: this.app.number_format(item.price, 2, '.', ' '),
            params: paramsHTML,
            deleteFunction: 'deleteCalcItem',
        }
    };

    this.inflateWidthSelector = function (first = null) {
        if (this.template.material > 0 && this.template.gab_height) {
            this.selectors.width.innerHTML = '';
            if (this.prices[this.template.material] && this.prices[this.template.material][this.template.gab_height]) {
                if (first && !this.prices[this.template.material][this.template.gab_height][first]) first = null;
                for (let n in this.prices[this.template.material][this.template.gab_height]) {
                    if (!first) first = n;
                    let option = document.createElement('option');
                    option.value = n;
                    option.innerHTML = (n / 10).toString();
                    this.selectors.width.appendChild(option);
                    if (!first) {
                        first = n;
                    } else {
                        if (first === n) option.selected = true;
                    }
                }
                this.template.gab_width = first;
            }
        }
    };
    this.inflateAmountSelector = function (first = null) {
        let ffirst = null;
        let selected = false;
        if (this.template.material > 0 && this.template.gab_height && this.template.gab_width) {
            this.selectors.amount.innerHTML = '';
            if (this.prices[this.template.material] && this.prices[this.template.material][this.template.gab_height] && this.prices[this.template.material][this.template.gab_height][this.template.gab_width]) {
                let amount = this.prices[this.template.material][this.template.gab_height][this.template.gab_width].amount;
                for (let i = 1; i <= 20; i++) {
                    let n = i * amount;
                    let option = document.createElement('option');
                    option.value = n;
                    option.innerHTML = n.toString();
                    this.selectors.amount.appendChild(option);
                    if (!ffirst) {
                        ffirst = n;
                    }
                    if (!first) {
                        first = n;
                    } else {
                        if (first === n) {
                            option.selected = true;
                            selected = true;
                        }
                    }
                }
                if (!selected && ffirst) {
                    this.template.amount = ffirst;
                } else {
                    this.template.amount = first;
                }
            }
        }
    };
    this.reCalc = function () {
        let cost = 0;
        let item = null;
        if (this.prices[this.template.material] && this.prices[this.template.material][this.template.gab_height] && this.prices[this.template.material][this.template.gab_height][this.template.gab_width]) {
            item = this.prices[this.template.material][this.template.gab_height][this.template.gab_width];

            if (item && item.crutch) {
                for (let key in item.crutch) {
                    if (Object.prototype.hasOwnProperty.call(item.crutch, key)) {
                        this.template[key] = item.crutch[key];
                    }
                }
            }
            if (item && item.cost) {
                cost = item.cost;
            }
        }
        if (this.cornice) {
            cost = this.prices[this.template.color][this.template.size]["cost"];
        }
        if (this.vformMaterial) {
            cost = ((parseFloat(this.prices[this.template.lamels][this.template.height]["cost"]) * this.template.height / 100) + parseFloat(this.prices[this.template.lamels][this.template.height]["cost_set"])) * parseFloat(this.prices[this.template.lamels][this.template.height]["multiplier"])
        }
        if (this.vformCornice) {
            let length = this.template.corniceSize / 100
            if (length < 1) {
                length = 1
            }
            cost = parseFloat(this.prices[this.template.mountType]["cost"]) * length
        }
        if (this.kit) {
            cost = this.prices[this.template.subtype]["cost"];
        }

        this.template.price = this.template.amount * cost;
        this.template.sale = 0;

        let mode = this.app.mode;

        let allItems = this.app.actionItems;

        let actionItemsAmount = 0;
        for (let item in allItems) {
            // console.log(allItems[item])
            actionItemsAmount += allItems[item].template.amount;
        }

        if (mode == 1) {
            if (this.materials[this.template.material] && this.materials[this.template.material].action && this.materials[this.template.material].actionMids.indexOf(String(this.mid)) != -1) {
                for (let saleRecord in this.materials[this.template.material].actionSales) {
                    // if (parseInt(this.materials[this.template.material].actionSales[saleRecord].goods) <= this.template.amount) {
                    if (parseInt(this.materials[this.template.material].actionSales[saleRecord].goods) <= actionItemsAmount) {
                        if (parseInt(this.template.sale) < parseInt(this.materials[this.template.material].actionSales[saleRecord].sale)) {
                            this.template.sale = this.materials[this.template.material].actionSales[saleRecord].sale;
                        }
                    }
                }
            }
        } else if (mode == 2) {
            if (this.materials[this.template.material] && this.materials[this.template.material].storageAction && this.materials[this.template.material].storageActionMids.indexOf(String(this.mid)) != -1) {
                for (let saleRecord in this.materials[this.template.material].storageActionSales) {
                    // if (parseInt(this.materials[this.template.material].storageActionSales[saleRecord].goods) <= this.template.amount) {
                    if (parseInt(this.materials[this.template.material].storageActionSales[saleRecord].goods) <= actionItemsAmount) {
                        if (parseInt(this.template.sale) < parseInt(this.materials[this.template.material].storageActionSales[saleRecord].sale)) {
                            this.template.sale = this.materials[this.template.material].storageActionSales[saleRecord].sale;
                        }
                    }
                }
            }
        }

        if (this.cornice || this.vformCornice) {
            let actions = this.app.actions;
            for (let action in actions) {
                if (actions[action].type == 1) {
                    let goodsArr = [];
                    if (actions[action].goodsArray != '') {
                        goodsArr = JSON.parse(actions[action].goodsArray)
                    }

                    for (let good in goodsArr) {
                        if (goodsArr[good].slice(0, 3) == 400 && this.vformCornice && actions[action].systemsMids.indexOf(String(this.mid)) != -1) { //VForm
                            if (parseInt(goodsArr[good].slice(7)) == this.template.mountType) {
                                let sales = JSON.parse(actions[action].saleJson);
                                for (let saleRecord in sales) {
                                    // if (parseInt(sales[saleRecord].goods) <= this.template.amount) {
                                    if (parseInt(sales[saleRecord].goods) <= actionItemsAmount) {
                                        if (parseInt(this.template.sale) < parseInt(sales[saleRecord].sale)) {
                                            this.template.sale = sales[saleRecord].sale;
                                        }
                                    }
                                }
                            }
                        }

                        if (goodsArr[good].slice(0, 3) == 401 && this.cornice) {
                            if (parseInt(goodsArr[good].slice(6,8)) == this.template.corniceSubtype && actions[action].systemsMids.indexOf(String(this.mid)) != -1) {
                                let sales = JSON.parse(actions[action].saleJson);
                                for (let saleRecord in sales) {
                                    // if (parseInt(sales[saleRecord].goods) <= this.template.amount) {
                                    if (parseInt(sales[saleRecord].goods) <= actionItemsAmount) {
                                        if (parseInt(this.template.sale) < parseInt(sales[saleRecord].sale)) {
                                            this.template.sale = sales[saleRecord].sale;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        this.template.salePrice = this.template.price - (this.template.sale / 100 * this.template.price);

        this.template.packSize = '';

        for (let item in this.packingData) {
            if (this.packingData[item].mid == this.template.mid) {
                if (this.template.mid != 202 && this.template.mid != 201) {
                    let itemWidth = JSON.parse(this.packingData[item].itemWidth)
                    for (let size in itemWidth) {
                        if (itemWidth[size] == this.template.gab_width / 10) {
                            this.template.packSize = this.packingData[item].packageSize;
                            this.template.packSize2 = this.packingData[item].packageSize2;
                            this.template.amountInPack = this.packingData[item].items;
                        }
                    }
                } else if (this.template.mid == 201) {
                    let itemWidth = JSON.parse(this.packingData[item].itemWidth)
                    for (let size in itemWidth) {
                        if (itemWidth[size] == this.template.corniceSize) {
                            this.template.packSize = this.packingData[item].packageSize;
                            this.template.packSize2 = this.packingData[item].packageSize2;
                            this.template.amountInPack = this.packingData[item].items;
                        }
                    }
                } else if (this.template.mid == 202) {
                    if (this.packingData[item].lamels == this.template.lamels) {
                        this.template.packSize = this.packingData[item].packageSize;
                        this.template.packSize2 = this.packingData[item].packageSize2;
                        this.template.amountInPack = this.packingData[item].items;
                    }
                }
            }
        }
    };

    this.inflateFabricsBlock = function (block, template, cb) {
        let materials = [];
        for (let key in this.materials) {
            if (Object.prototype.hasOwnProperty.call(this.materials, key))
                if (this.materials[key]) materials.push(this.materials[key]);
        }
        materials.sort(window.dynamicSort("name"));
        block.innerHTML = '';
        for (let mat of materials) {
            let item = this.app.HTMLDOM(template, mat);
            item.enabled = true;

            block.appendChild(item);

            if (mat.gdsInStock <= 0) {
                let msg = item.querySelectorAll('[model="msg"]')[0];
                if (msg) msg.innerHTML = 'Временно нет в наличии!';

                item.enabled = false;
                item.style.backgroundColor = 'rgba(255, 134, 134, 0.76)';
            }
        }

        if (cb) cb(block);
    };
    this.chooseFabric = function (id) {
        id = parseInt(id);
        if (this.materials[id]) {
            this.template.material = id;
            this.reCalc();
        }
    };

    this.destroy = function () {
    };

    this.init();
};
export default RMCalc;
